// extracted by mini-css-extract-plugin
export default {"container":"add-insurance-page_container__ks4UQ","alert":"add-insurance-page_alert__CXprH"};